import type { TOC } from '@ember/component/template-only';

import FormCheckboxComponent from 'webapp/components/form/checkbox';
import FormSliderComponent from 'webapp/components/form/slider';
import SubmitButtonComponent from 'webapp/components/submit-button';

interface Args {
	quantity: number;
	max: number;
	confirmed: boolean;
	confirmName: string;
	confirmLabel: string;
	finePrint: string;
	isConfirmDisabled: boolean;
	submitInProgress: boolean;
	onSliderChange: (value: number) => void;
	onConfirmChange: (value: boolean) => void;
	onSave: () => void;
	onClose: () => void;
}

interface Signature {
	Args: Args;
	Blocks: {
		count: [];
		summary: [];
		beforeSlider: [];
	};
}

const BillingQuantifiableAddonUpdateWrapperComponent: TOC<Signature> = <template>
	<div class="quantifiable-addon">
		<div class="quantifiable-addon__selector">
			<div class="quantifiable-addon__count">
				{{yield to="count"}}
			</div>
			{{yield to="beforeSlider"}}
			<FormSliderComponent
				@min={{0}}
				@max={{@max}}
				@step={{1}}
				@value={{@quantity}}
				@onChange={{@onSliderChange}}
			/>
		</div>

		{{yield to="summary"}}

		<div class="quantifiable-addon__confirm">
			<FormCheckboxComponent
				@name={{@confirmName}}
				@selected={{@confirmed}}
				@label={{@confirmLabel}}
				@onChange={{@onConfirmChange}}
			/>
		</div>

		<p class="quantifiable-addon__fine-print">{{@finePrint}}</p>

		<div class="controls2">
			<div class="controls2__right">
				<SubmitButtonComponent
					@text="Cancel"
					@theme="grey-empty"
					@noDelay={{true}}
					@onTrigger={{@onClose}}
				/>
				<SubmitButtonComponent
					@text="Confirm"
					@extraClass="save"
					@isDisabled={{@isConfirmDisabled}}
					@onTrigger={{@onSave}}
					@submitInProgress={{@submitInProgress}}
				/>
			</div>
		</div>
	</div>
</template>;

export default BillingQuantifiableAddonUpdateWrapperComponent;
